import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Image, Button } from "react-bootstrap";
import { getDistance } from "geolib";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import Dropdown from "react-dropdown";
import ChangingProgressProvider from "./ChangingProgressProvider";
import "react-circular-progressbar/dist/styles.css";
import uuid from "react-uuid";
import { withTranslation } from "react-i18next";

import ProgressBar from "../../../components/UI/ProgressBar/ProgressBar";
import CustomButton from "../../../components/UI/Button/Button";
import * as providerDetailsActions from "../../../store/actions/index";
import Modal from "../../../components/UI/Modal/Modal";
import { Contact } from "../../../components/UI/Alerts/ContactAlert/ContactAlert";
import Feedback from "../Feedback/Feedback";
import ProviderMaps from "../../../components/UI/ProviderMaps/ProviderMaps";
import Spinner from "../../../components/UI/Spinner/Spinner";
import InfoWindow from "../../../components/UI/Alerts/InfoWindow/InfoWindow";
import classes from "./ProviderDetails.module.css";

// import info from "../../../assets/images/info-icon.svg";
import arrowLeft from "../../../assets/images/arrow-left.svg";
import statusImage from "../../../assets/images/icon-status.svg";
import shieldImage from "../../../assets/images/icon-shield.png";
import location from "../../../assets/images/icon-location.svg";
import call from "../../../assets/images/icon-call.svg";
import share from "../../../assets/images/icon-share.svg";
import ImgFeedback from "../../../assets/images/icon-feedback.svg";
import subcategory from "../../../assets/images/subcategory-marker.png";
import infoWindow from "../../../assets/images/info-icon.svg";
import likeSelected from "../../../assets/images/icon-like-selected.svg";
import provider1 from "../../../assets/images/img-provider1.svg";
import provider2 from "../../../assets/images/img-provider2.svg";
import provider3 from "../../../assets/images/img-provider3.svg";
import heart from "../../../assets/images/heart-blue-boundary.svg";
import { logFirebaseEvent } from "../../../shared/utility";
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import { toast } from "react-toastify";

interface IParentProps {
  providerId: string;
  distance: number;
  postalCode: string;
  npi: string;
  orgDistance: string;
  contractStatus: string;
  onClick: () => void;
}
interface IStateFromProps {
  provider: {
    providerId: string;
    providerName: string;
    providerEntityType: string;
    providerLabels: string[];
    longitude: number;
    latitude: number;
    address: string;
    city: string;
    state: string;
    isNational:boolean;
    hospitalName: string;
    postalCode: string;
    phoneNumber: string;
    providerType: string;
    specialty: string[];
    isContracted: boolean;
    isPreferred: boolean;
    favoriteId: string;
    isFavorite: boolean;
    totalExperienceScore: number;
    distance: number;
    gender: string;
    experienceScore: {
      label: string;
      value: number;
    }[];
    qualityScore: {
      label: string;
      value: number;
    }[];
    quantrosScores: {
      category: string;
      scores: { name: string; order: number; score: number }[];
    }[];
    medicareValue: number;
    npi: string;
    orgDistance: string;
    orgPostalCode: string;
    finderLabel: string;
    additionalLocations: {
      addressId: number;
      addressTypeId: number;
      id: number;
      address:{
        addressLine1: string;
        addressLine2: string;
        city: string;
        latitude: number;
        longitude: number;
        postalCode: string;
        state: string;
      }[]
    }[];
    additionalLocationsCount: number;
  };
  latitude: number;
  longitude: number;
  loading: boolean;
  error: boolean;

  qualityScoreCategoryId: {
    label: string;
    values: {
      name: string;
      id: string;
      order: number;
      score: number;
    }[];
  };
  loadingCategoryId: boolean;
  errorCategoryId: boolean;

  // qualityScoreCategories: {
  //   label: string;
  //   values: {
  //     name: string;
  //     id: string;
  //     order: number;
  //   }[];
  // };
  loadingCategories: boolean;
  errorCategories: boolean;
  t: any;
}
interface IDispatchFromProps {
  onFetchProviderDetails: (
    providerId: string,
    npi: string,
    distance: number,
    postalCode: string,
    orgDistance: string,
    contractStatus: string
  ) => void;
  onFavoriteProvider: (
    providerId: number,
    npi: string,
    postalCode: string
  ) => void;
  onUnfavoriteProvider: (favoriteId: string) => void;
  onFetchCurrentLocation: () => void;
  onSubmitFeedbackReset: () => void;
  onFetchQualityScoreCategories: (providerId: string) => void;
  onFetchQualityScoreCategoryId: (
    providerId: string,
    categoryId: string
  ) => void;
}
type Props = IParentProps & IStateFromProps & IDispatchFromProps;

const btnStyle = { marginTop: "5px", 'min-width': 'auto' };

class ProviderDetails extends Component<Props> {
  state = {
    connect: false,
    submitFeedback: false,
    latitude: 0,
    longitude: 0,
    favorite: this.props.provider.isFavorite,
    distance: 0,
    choosenCategory: "",
    choosenCategoryId: 0,
    showInfoWindow: false,
    selectedAddress:undefined,
    columns: [{
      dataField: 'id',
      text: 'ID',
      hidden: true,
      sort: true
    }, {
      dataField: 'address',
      text: 'Address',
      formatter: (cell,row) => this.formatAddress(row)
    }, {
      dataField: 'showOnMap',
      text: 'Show Maps',
      headerStyle: { 'text-align': 'center' },
      style: {'text-align': 'end'},
      formatter:(cell,row) => this.renderMaps(row)
    }]
  };

  formatAddress(row) {
    return (
      <div>
        <span>
          {row.address.addressLine1} {row.address.addressLine2}
        </span>
        <br />
        <span>
         {row.address.city}, {row.address.state} {this.formatZipCode(row.address.postalCode)}
        </span>
      </div>
    )
  }
  
  formatZipCode =(value) => {
    let formattedZipCode = value
    if (value) {
      if (formattedZipCode.length > 5) {
        formattedZipCode = `${value.slice(0, 5)}-${value.slice(5, formattedZipCode.length)}`
      }
    }
    return formattedZipCode
  }

   renderMaps(row) {
    let { t } = this.props;
    if (!row.address.latitude || !row.address.longitude) return null
    return (
      <div>
           <CustomButton
            label={t("providerDetails.showOnMap")}
            clicked={()=>{this.setState({selectedAddress:row.address})}}
            displayImg={false}
            style={btnStyle}
            image=""
            disabled={false}
          />
        </div>
    )
  }

  shareHandler = (provider) => {
    let mailContent = "Subject=Provider Details&";
    mailContent += "body=";
    if (provider) {
      mailContent += encodeURIComponent(
        `https://www.google.com/maps/dir/?api=1&origin=${this.state.latitude} ${this.state.longitude}&destination=${provider["latitude"]} ${provider["longitude"]}&travelmode=driving`
      );
    }
    window.location.href = `mailto:?${mailContent}`;
  };

  contactHandler = () => {
    this.setState({ connect: true });
  };
  connectedHandler = () => {
    this.setState({ connect: false });
  };
  componentDidMount() {
    logFirebaseEvent("DetailView");
    this.props.onFetchProviderDetails(
      this.props.providerId,
      this.props.npi,
      this.props.distance,
      this.props.postalCode,
      this.props.orgDistance,
      this.props.contractStatus
    );
    // this.getCurrentLocation();
    this.props.onFetchCurrentLocation();
  }
  getDirectionsHandler = (provider) => {
    window.open(
      `https://www.google.com/maps/dir/?api=1&origin=${this.state.latitude} ${this.state.longitude}&destination=${provider.latitude} ${provider.longitude}&travelmode=driving`
    );
  };

  submitFeedbackHandler = () => {
    this.setState({ submitFeedback: true });
  };
  feedbackSubmittedHandler = () => {
    this.setState({ submitFeedback: false });
    toast("Thank you for your feedback!", {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 10000,
      hideProgressBar: true,
      closeOnClick: true,
      progress: undefined,
    });
  };
  showInfoWindow = () => {
    this.setState({ showInfoWindow: true });
  };
  hideInfoWindow = () => {
    this.setState({ showInfoWindow: false });
  };
  favoriteHandler = (providerId, npi, postalCode) => {
    console.log("favoriteHandler", providerId);
    this.props.onFavoriteProvider(providerId, npi, postalCode);
    this.setState({ favorite: true });
  };
  notFavoriteHandler = (favoriteId) => {
    console.log("notFavoriteHandler");
    console.log("favoriteId", favoriteId);
    if (favoriteId) {
      this.props.onUnfavoriteProvider(favoriteId);
    }
    this.setState({ favorite: false });
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.latitude &&
      this.props.longitude &&
      prevProps.provider !== this.props.provider
    ) {
      const distance =
        getDistance(
          {
            latitude: this.props.latitude,
            longitude: this.props.longitude,
          },
          {
            latitude: this.props.provider.latitude,
            longitude: this.props.provider.longitude,
          }
        ) * 0.000621371;
      this.setState({ distance: distance });
      this.setState({ latitude: this.props.latitude });
      this.setState({ longitude: this.props.longitude });
    }

    if (
      this.props.provider.providerId !== "" &&
      JSON.stringify(prevProps.provider) !== JSON.stringify(this.props.provider)
    ) {
      this.setState({
        choosenCategory:
          this.props.provider &&
          this.props.provider.quantrosScores &&
          this.props.provider.quantrosScores.length > 0 &&
          this.props.provider.quantrosScores[0].category,
      });
      this.setState({
        choosenCategoryId: 0,
      });
      // this.props.onFetchQualityScoreCategoryId(
      //   this.props.provider.providerId,
      //   ``
      // );
      // this.props.onFetchQualityScoreCategoryId(
      //   this.props.provider.providerId,
      //   ``
      // );
      // this.props.onFetchQualityScoreCategories(this.props.provider.providerId);
      // this.setState({
      //   choosenCategory: this.props.qualityScoreCategories.values[
      //           this.props.qualityScoreCategories.values.findIndex(
      //             (category) => category.order === 0
      //           )
      //         ].name,
      // })
    }

    // if (
    //   JSON.stringify(prevProps.qualityScoreCategories) !==
    //     JSON.stringify(this.props.qualityScoreCategories) &&
    //   this.props.qualityScoreCategories.values &&
    //   this.props.qualityScoreCategories.values.length > 0
    // ) {
    //   this.setState({
    //     choosenCategory: this.props.qualityScoreCategories.values[
    //       this.props.qualityScoreCategories.values.findIndex(
    //         (category) => category.order === 0
    //       )
    //     ].name,
    //   });
    //   this.setState({
    //     choosenCategoryId: this.props.qualityScoreCategories.values[
    //       this.props.qualityScoreCategories.values.findIndex(
    //         (category) => category.order === 0
    //       )
    //     ].id,
    //   });
    // }

    if (prevState.choosenCategoryId !== this.state.choosenCategoryId) {
      // this.props.onFetchQualityScoreCategoryId(
      //   this.props.provider.providerId,
      //   this.state.choosenCategoryId
      // );
    }
  }
  onClickMapInfoWindow = () => {};
  categoryHandleChange = (e) => {
    console.log("category", e.value, e.label);
    this.setState({ choosenCategory: e.label });
    this.setState({ choosenCategoryId: e.value });
  };
  providerMedicareSelection = (
    provider: {
      providerId: string;
      providerName: string;
      providerEntityType: string;
      providerLabels: string[];
      longitude: number;
      latitude: number;
      address: string;
      city: string;
      state: string;
      hospitalName: string;
      postalCode: string;
      phoneNumber: string;
      providerType: string;
      specialty: string[];
      isContracted: boolean;
      favoriteId: string;
      isFavorite: boolean;
      totalExperienceScore: number;
      distance: number;
      gender: string;
      experienceScore: {
        label: string;
        value: number;
      }[];
      qualityScore: {
        label: string;
        value: number;
      }[];
      quantrosScores: {
        category: string;
        scores: { name: string; order: number; score: number }[];
      }[];
      medicareValue: number;
      npi: string;
      orgDistance: string;
      orgPostalCode: string;
      finderLabel: string;
    },
    providerMedicare: any
  ) => {
    if (provider.medicareValue === 0) {
      providerMedicare = (
        <div className={[classes.cardLink, classes.dollar].join(" ")}>
          <span>$</span>
          <span>$</span>
          <span>$</span>
          <span>$</span>
          <span>$</span>
        </div>
      );
    } else if (provider.medicareValue === 1) {
      providerMedicare = (
        <div className={[classes.cardLink, classes.dollar].join(" ")}>
          <span className={classes.active}>$</span>
          <span>$</span>
          <span>$</span>
          <span>$</span>
          <span>$</span>
        </div>
      );
    } else if (provider.medicareValue === 2) {
      providerMedicare = (
        <div className={[classes.cardLink, classes.dollar].join(" ")}>
          <span className={classes.active}>$</span>
          <span className={classes.active}>$</span>
          <span>$</span>
          <span>$</span>
          <span>$</span>
        </div>
      );
    } else if (provider.medicareValue === 3) {
      providerMedicare = (
        <div className={[classes.cardLink, classes.dollar].join(" ")}>
          <span className={classes.active}>$</span>
          <span className={classes.active}>$</span>
          <span className={classes.active}>$</span>
          <span>$</span>
          <span>$</span>
        </div>
      );
    } else if (provider.medicareValue === 4) {
      providerMedicare = (
        <div className={[classes.cardLink, classes.dollar].join(" ")}>
          <span className={classes.active}>$</span>
          <span className={classes.active}>$</span>
          <span className={classes.active}>$</span>
          <span className={classes.active}>$</span>
          <span>$</span>
        </div>
      );
    } else if (provider.medicareValue === 5) {
      providerMedicare = (
        <div className={[classes.cardLink, classes.dollar].join(" ")}>
          <span className={classes.active}>$</span>
          <span className={classes.active}>$</span>
          <span className={classes.active}>$</span>
          <span className={classes.active}>$</span>
          <span className={classes.active}>$</span>
        </div>
      );
    } else {
      providerMedicare = (
        <div className={[classes.cardLink, classes.dollar].join(" ")}>
          <span className={classes.active}>$</span>
          <span className={classes.active}>$</span>
          <span className={classes.active}>$</span>
          <span className={classes.active}>$</span>
          <span className={classes.active}>$</span>
        </div>
      );
    }
    return providerMedicare;
  };

  render() {
    let { t } = this.props;
    console.log("this.props.provider", this.props.provider);
    console.log("this.state.choosenCategory", this.state.choosenCategory);
    console.log("this.state.choosenCategoryId", this.state.choosenCategoryId);
    const {
      onClick,
      provider,
      // qualityScoreCategoryId,
      // qualityScoreCategories,
    } = {
      ...this.props,
    };
    const modalContact = {
      width: "480px",
      left: "calc(50% - 240px)",
    };
    // const options =
    //   qualityScoreCategories &&
    //   qualityScoreCategories.values &&
    //   qualityScoreCategories.values.length > 0
    //     ? qualityScoreCategories.values.map((res) => ({
    //         value: res.id,
    //         label: res.name,
    //       }))
    //     : ["Select"];
    const options =
      this.props.provider &&
      this.props.provider.quantrosScores &&
      this.props.provider.quantrosScores.length > 0
        ? this.props.provider.quantrosScores.map((scoreCategory, index) => ({
            value: index.toString(),
            label: scoreCategory.category,
          }))
        : ["Select"];
    // const percentage =
    //   qualityScoreCategoryId &&
    //   qualityScoreCategoryId.values &&
    //   qualityScoreCategoryId.values.length > 0
    //     ? qualityScoreCategoryId.values[
    //         qualityScoreCategoryId.values.findIndex(
    //           (category) => category.order === 0
    //         )
    //       ].score
    //     : 0;
    const percentage =
      this.props.provider &&
      this.props.provider.quantrosScores &&
      this.props.provider.quantrosScores.length > 0
        ? this.props.provider.quantrosScores[this.state.choosenCategoryId]
            .scores[
            this.props.provider.quantrosScores[
              this.state.choosenCategoryId
            ].scores.findIndex((score) => score.order === 0)
          ].score
        : 0;
    const subcategories =
      // qualityScoreCategoryId.values &&
      // qualityScoreCategoryId.values.length > 0 &&
      // qualityScoreCategoryId.values.map((res) => {
      this.props.provider &&
      this.props.provider.quantrosScores &&
      this.props.provider.quantrosScores.length > 0 &&
      this.props.provider.quantrosScores[
        this.state.choosenCategoryId
      ].scores.map((res) => {
        if (res.order !== 0) {
          return (
            <li key={uuid()}>
              <ChangingProgressProvider values={[res.score]}>
                {(value: number) => (
                  <CircularProgressbar
                    value={value ? value : 0}
                    text={value ? `${value}` : `N/A`}
                    circleRatio={0.5}
                    strokeWidth={15}
                    styles={buildStyles({
                      rotation: 1 / 2 + 1 / 4,
                      strokeLinecap: "butt",
                      textSize: "18px",
                      pathColor: "#88C5FA",
                      textColor: "#555",
                      trailColor: "#d8d8d8",
                    })}
                  />
                )}
              </ChangingProgressProvider>
              <p>
                {res.name === "Complication Rate"
                  ? t("provider.complecationRate")
                  : res.name === "Patient Safety"
                  ? t("provider.patiantSafety")
                  : res.name === "Inpatient Quality"
                  ? t("provider.inpatient")
                  : res.name === "Readmissions"
                  ? t("provider.readmission")
                  : res.name === "Morality"
                  ? t("provider.mortality")
                  : res.name}
              </p>
            </li>
          );
        }
        return null;
      });

    /* Loading */
    let spinner: any;
    if (this.props.loading) {
      spinner = <Spinner />;
    }
    /* Connect Alert*/
    let connectAlert: any;
    if (this.state.connect) {
      connectAlert = (
        <Modal
          show={this.state.connect}
          childComp={
            <Contact
              modalClosed={this.connectedHandler}
              contactNumber={provider.phoneNumber}
            />
          }
          style={modalContact}
        ></Modal>
      );
    }
    /* Submit <Feedback></Feedback>*/
    let feedbackAlert: any;
    if (this.state.submitFeedback) {
      this.props.onSubmitFeedbackReset();
      feedbackAlert = (
        <Modal
          show={this.state.submitFeedback}
          childComp={
            <Feedback
              t={t}
              provider={provider}
              modalClosed={this.feedbackSubmittedHandler}
              logEvent="FeedbackButtonPressed"
            />
          }
          style={modalContact}
        ></Modal>
      );
    }
    let infoWindowAlert: any;
    if (this.state.showInfoWindow) {
      infoWindowAlert = (
        <Modal
          show={this.state.showInfoWindow}
          childComp={
            <InfoWindow
              modalClosed={this.hideInfoWindow}
              infoText={t("providerDetails.providerInfo")}
            />
          }
          style={modalContact}
        />
      );
    }

    let mainInfo: any;

    mainInfo = (
      <div className={classes.quickInfo}>
        <h4>
          {provider.providerName}
          <span className={[classes.cardLike, classes.noPointer].join(" ")}>
            {provider.isFavorite ? (
              <Image src={likeSelected} alt="favorite" />
            ) : (
              <Image src={heart} alt="notfavorite" />
            )}
          </span>
        </h4>
        <span>{provider.providerEntityType}</span>
         {provider.isNational? <span>National</span>:undefined}     
        {/* <span>{`${provider.providerType}-${provider.specialty}`}</span> */}
      </div>
    );

    let scoreDisplay: any;

    if (provider.experienceScore && provider.experienceScore[0].value > 0) {
      if (provider.isContracted || provider.isPreferred) {
        scoreDisplay = (
          <div className="statusDone">
            <Image src={shieldImage} alt="shieldImage" />
          </div>
        );
      } else {
        scoreDisplay = (
          <div className="status">
            <Image src={statusImage} alt="statusImage" />
            <strong>{provider.experienceScore[0].value}</strong>
          </div>
        );
      }
    }

    let qualityScoresSection: any;
    if (
      // this.props.qualityScoreCategories.values &&
      // this.props.qualityScoreCategories.values.length > 0
      this.props.provider &&
      this.props.provider.quantrosScores &&
      this.props.provider.quantrosScores.length > 0
    ) {
      qualityScoresSection = (
        <div className={classes.scoreSec}>
          <div className={classes.scoreHead}>
            <h6>
              {t("providerPage.qualityScores")}
              {/* <Image src={info} alt="info" /> */}
            </h6>
          </div>
          {/* {provider.qualityScore &&
                      provider.qualityScore.map((score, index) => (
                        <ul key={index}>
                          <li>{score.label}</li>
                          <li>
                            <ProgressBar
                              bgcolor="#4bc2d4"
                              completed={score.value ? score.value : 0}
                            />
                          </li>
                        </ul>
                      ))} */}
          <ul className={classes.scoreSel}>
            <li>
              <strong className="text-secondary">
                {t("providerPage.category")}
              </strong>
            </li>
            <li>
              <Dropdown
                className="dropdown-manual"
                options={options}
                value={this.state.choosenCategory}
                onChange={(e) => this.categoryHandleChange(e)}
                placeholder={t("placeHolder.selectAnOption")}
              />
            </li>
          </ul>
          <div className={classes.scoreCat}>
            <div onClick={this.showInfoWindow}>
              <Image
                src={infoWindow}
                alt={infoWindow}
                className={classes.infoWindow}
              />
            </div>

            <div className={classes.scoreBar}>
              {percentage !== 0 && (
                <CircularProgressbar
                  value={percentage ? percentage : 0}
                  text={percentage ? `${percentage}` : `N/A`}
                  strokeWidth={15}
                  styles={buildStyles({
                    rotation: 0.0,
                    strokeLinecap: "butt",
                    textSize: "24px",
                    pathColor: `#88C5FA`,
                    textColor: "#555",
                    trailColor: "#d8d8d8",
                  })}
                />
              )}
            </div>
          </div>
          <div className={classes.scoreSubCat}>
            <Image
              src={subcategory}
              alt={subcategory}
              className={classes.subcategory}
            />
            <p className="text-left">{t("providerPage.subCategory")}</p>
            <ul>{subcategories}</ul>
          </div>
        </div>
      );
    } else {
      qualityScoresSection = null;
    }

    let additonalLocationSection: any;
    if (provider.additionalLocations && provider.additionalLocations.length > 0){
        additonalLocationSection = (
            <div className={classes.additionalLocations}>
                  <h6>{t("providerDetails.additionalLocations")}</h6>
                    <div className={classes.additionalLocationsIn}>
                      {provider.additionalLocations && provider.additionalLocations.length > 0 &&
                        <BootstrapTable
                          keyField = "id"
                          data = { provider.additionalLocations }
                          columns = { this.state.columns }
                          bordered = { false }
                          striped
                          //pagination={paginationFactory()}
                        />
                      }
                  </div>
            </div>
          );
    }else {
      additonalLocationSection = null;
    }

    let providerMedicare: any;
    providerMedicare = this.providerMedicareSelection(
      provider,
      providerMedicare
    );
    let providerImage: any;
    if (provider.providerEntityType.toLowerCase() === "individual") {
      providerImage = <Image src={provider1} alt="provider" />;
    } else if (provider.providerEntityType.toLowerCase() === "organization") {
      providerImage = <Image src={provider2} alt="provider" />;
    } else {
      providerImage = <Image src={provider3} alt="provider" />;
    }
    const nextBtnStyle = { width: "100%", marginTop: "30px" };
    const providerDetails =
      provider && provider.providerId !== "" ? (
        // <Fragment>
        //   {connectAlert}
        //   {feedbackAlert}
        //   {infoWindowAlert}
        <div>
          {/* <div className={classes.resLeft}>
              <Button className="btnLink iconLeft" onClick={onClick}>
                <Image src={arrowLeft} alt="arrowLeft" />
                {t("balanceBilling.backToList")}
              </Button>
            </div> */}
          <div className={classes.resRight}>
            <Button
              className="btnLink iconRight"
              onClick={this.submitFeedbackHandler}
            >
              {t("balanceBilling.feedback")}
              <Image src={ImgFeedback} alt="ImgFeedback" />
            </Button>
          </div>
          <div className="clear"></div>

          <div className="tabsContentMain">
            <div className={classes.providerInformation}>
              <div className={classes.provInfo}>
                {mainInfo}
                <div className={classes.provImage}>
                  <div className={classes.provImageLarge}>
                    {/* <Image
                      src={provider1}
                      alt="provider"
                    />
                    <Image
                      src={provider2}
                      alt="provider"
                    /> */}
                    {/* <Image src={provider3} alt="provider" /> */}
                    {providerImage}
                  </div>
                  {scoreDisplay}
                </div>
                <div className={classes.cardLinks}>
                  {!provider.isNational?
                  <div
                    className={[
                      classes.cardLink,
                      classes.locationAdj,
                      classes.noPointer,
                    ].join(" ")}
                  >
                    <Image src={location} alt="location" />
                    <span>
                      {this.state.distance
                        ? `${this.state.distance.toFixed(1)} mi`
                        : `N/A`}
                    </span>
                  </div>:undefined}
                  {/* <div
                      className={[classes.cardLink, classes.noPointer].join(
                        " "
                      )}
                    >
                      {provider.isFavorite ? (
                        <Image src={likeSelected} alt="favorite" />
                      ) : (
                        <Image src={heart} alt="notfavorite" />
                      )}
                    </div> */}
                  {/* <div
                      className={[classes.cardLink, classes.dollar].join(" ")}
                    >
                      <span className={classes.active}>$</span>
                      <span>$</span>
                      <span>$</span>
                      <span>$</span>
                      <span>$</span>
                    </div> */}
                  {providerMedicare}
                  <div
                    className={classes.cardLink}
                    onClick={this.contactHandler}
                  >
                    <Image src={call} alt="call" />
                  </div>
                  <div
                    className={classes.cardLink}
                    onClick={() => this.shareHandler(provider)}
                  >
                    <Image src={share} alt="share" />
                  </div>
                </div>
                {/* <div className={classes.spec}>
                    <h6>Specialties</h6>
                    <p>{provider.specialty}</p>
                  </div> */}

                {!(provider.isContracted || provider.isPreferred) && (
                  <div className={classes.spec}>
                    <h6>{t("providerDetails.score")}</h6>
                    {provider.experienceScore &&
                      provider.experienceScore.map((score, index) => {
                        if (
                          !score.label.toLowerCase().match(/experience score/g)
                        )
                          return (
                            <ul key={index}>
                              <li>{score.label}</li>
                              <li>
                                <ProgressBar
                                  bgcolor="#4bc2d4"
                                  completed={score.value ? score.value * 20 : 0}
                                />
                              </li>
                            </ul>
                          );
                        return null;
                      })}
                  </div>
                )}
                {qualityScoresSection}
                <div className={classes.specialities}>
                  <h6>{t("providerDetails.specialities")}</h6>
                  <div className={classes.specialitiesIn}>
                    <ul>
                      {provider.specialty.length > 0 &&
                        provider.specialty.map((specialty) => (
                          <li>
                            <span>{specialty}</span>
                          </li>
                        ))}
                    </ul>
                  </div>
                </div>
                {/* specialities end  */}
                {additonalLocationSection}
              </div>

              {!provider.isNational?
              <div className={classes.provDetails}>
                <div className={classes.mapView}>
                  <ProviderMaps
                    markers={[provider]}
                    onClick={this.onClickMapInfoWindow}
                    view="details"
                    addresses={this.state.selectedAddress ? [this.state.selectedAddress]:[]}
                  />
                </div>
                <div className={classes.provAddress}>
                  <h5>{t("findProviderPage.location")}</h5>
                  <p>{provider.address}</p>
                  <p>{provider.city}</p>
                  <p>{provider.state}</p>
                  <p>{provider.postalCode}</p>

                  <CustomButton
                    label={t("findProviderPage.getDirections")}
                    style={nextBtnStyle}
                    clicked={() => this.getDirectionsHandler(provider)}
                    displayImg={false}
                    image=""
                    disabled={false}
                  />
                </div>
              </div>:undefined}
              <div className="clear"></div>
            </div>
          </div>
        </div>
      ) : (
        // </Fragment>
        <div className="tabsContentMain">
          <div className={classes.noResults}>
            {/* {t("providerDetails.errorMsg")} */}
            {t("providerDetails.detailsNotFoundMainText")}
            {/* Your providers information has been updated. */}
            <br />
            {t("providerDetails.detailsNotFoundSubText")}
          </div>
        </div>
      );
    return (
      <div>
        {spinner}
        <Fragment>
          {connectAlert}
          {feedbackAlert}
          {infoWindowAlert}
          <div>
            <div className={classes.resLeft}>
              <Button
                className="btnLink iconLeft"
                style={{ position: "relative", zIndex: 1 }}
                onClick={onClick}
              >
                <Image src={arrowLeft} alt="arrowLeft" />
                {t("balanceBilling.backToList")}
              </Button>
            </div>
            {providerDetails}
          </div>
        </Fragment>
      </div>
    );
  }
}
const mapStateToProps = (state: any) => ({
  provider: state.providerDetails.provider,
  loading: state.providerDetails.loading,
  error: state.providerDetails.error,
  latitude: state.fetchCurrentLocation.latitude,
  longitude: state.fetchCurrentLocation.longitude,
  qualityScoreCategoryId:
    state.fetchQualityScoreCategoryId.qualityScoreCategoryId,
  loadingCategoryId: state.fetchQualityScoreCategoryId.loading,
  errorCategoryId: state.fetchQualityScoreCategoryId.error,
  qualityScoreCategories:
    state.fetchQualityScoreCategories.qualityScoreCategories,
  loadingCategories: state.fetchQualityScoreCategories.loading,
  errorCategories: state.fetchQualityScoreCategories.error,
});
const mapDispatchToProps = (dispatch): IDispatchFromProps => ({
  onFetchProviderDetails: (
    providerId,
    npi,
    distance,
    postalCode,
    orgDistance,
    contractStatus
  ) =>
    dispatch(
      providerDetailsActions.fetchProvider(
        providerId,
        npi,
        distance,
        postalCode,
        orgDistance,
        contractStatus
      )
    ),
  onFavoriteProvider: (providerId, npi, postalCode) =>
    dispatch(
      providerDetailsActions.favoriteProvider(providerId, npi, postalCode)
    ),
  onUnfavoriteProvider: (favoriteId) =>
    dispatch(providerDetailsActions.unfavoriteProvider(favoriteId)),
  onFetchCurrentLocation: () =>
    dispatch(providerDetailsActions.fetchCurrentLocation()),
  onSubmitFeedbackReset: () =>
    dispatch(providerDetailsActions.submitFeedbackReset()),
  onFetchQualityScoreCategories: (providerId: string) =>
    dispatch(providerDetailsActions.fetchQualityScoreCategories(providerId)),
  onFetchQualityScoreCategoryId: (providerId: string, categoryId: string) =>
    dispatch(
      providerDetailsActions.fetchQualityScoreCategoryId(providerId, categoryId)
    ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(ProviderDetails));
